<template>
    <ul class="nav nav-mobile-menu">
        <li>
            <!-- <router-link to="/user">
                <div class="md-list-item-content md-ripple">
                    <i class="material-icons">person</i>
                    <p>Profile</p>
                </div>
            </router-link> -->
            <!-- <a href="/user" data-toggle="dropdown" class="dropdown-toggle">
                <i class="material-icons">person</i>
                <p>Profile</p>
            </a> -->
        </li>
    </ul>
</template>
<script>
export default {
};
</script>
